'use strict';

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

module.exports = function (_ref) {
  var libp2p = _ref.libp2p;
  return withTimeoutOption(function connect(addr, options) {
    return libp2p.dial(addr, options);
  });
};